import React from "react";
import { Chip } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

export function ResellerChip({ sx }: { sx?: SxProps<Theme> }) {
  return <Chip label="Reseller" size="small" variant="outlined" sx={sx} />;
}
